import * as React from "react";
const SvgArrow = props => <svg xmlns="http://www.w3.org/2000/svg" width={9} height={5} fill="none" viewBox="0 0 9 5" {...props}><path fill="#A1ACC3" d="m4.099.052 4.054 4.013H.044z" /></svg>;
export { SvgArrow as ReactComponent };